import { fromJS, Map } from 'immutable';
import { SET_ALL_CARDS, SET_CARDS } from './constants';

const initialState = fromJS({
  cardsById: {},
  cardsLoaded: false,
  /** Every card of every set, for the card lookup; null until it's opened. */
  allCards: null,
});

const byId = (cards) => Map(cards.map(card => [card.get('id'), card]));

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CARDS:
      return state.set('cardsById', byId(action.payload.get('cards'))).set('cardsLoaded', true);

    case SET_ALL_CARDS:
      return state.set('allCards', byId(action.payload.get('cards')));

    default:
      return state;
  }
}

export default reducer;
